import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { TextButton } from '../TextButton';
import styles from './FilterPickerGroup.module.scss';
export const filterPickerGroupClearTestId = (parentTestId)=>parentTestId ? "".concat(parentTestId, "-clear") : 'clear';
export function FilterPickerGroup(props) {
    const { className, style, children, flexWrap, onClearClick, disableClear, testId, clearLabel = 'Clear', modernClearButton = false } = props;
    const clearStyle = modernClearButton ? {
        skin: 'primary',
        underline: 'none',
        weight: 'normal',
        variant: 'paragraph2'
    } : {
        skin: 'secondary'
    };
    return /*#__PURE__*/ _jsxs("div", {
        style: style,
        className: cn(styles.root, {
            [styles.flexWrap]: flexWrap
        }, className),
        "data-testid": testId,
        children: [
            children,
            onClearClick ? /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({
                onClick: onClearClick
            }, clearStyle), {
                disabled: disableClear,
                testId: filterPickerGroupClearTestId(testId),
                bi: {
                    name: 'clear_filters'
                },
                children: clearLabel
            })) : null
        ]
    });
}
